import {
  ENGINE_REPORT_STORE_ID,
  EngineReport,
  EngineReportCylinderUnit,
  EngineReportDetails,
} from '@navstation-portal/reporting/data-model/engine-report';
import { EngineReportType } from '@navstation-portal/reporting/data-model/engine-reports';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const engineReportEvents = eventGroup({
  source: ENGINE_REPORT_STORE_ID,
  events: {
    createReport: type<{ reportType: EngineReportType }>(),
    createReportSuccess: type<{ localReportId: string; reportType: EngineReportType }>(),
    openReport: type<{ vesselId: string; reportId: string }>(),
    openReportSuccess: type<{ report: EngineReport }>(),
    openReportFailed: type<{ error: string }>(),
    selectEngine: type<{ engineIndex: number }>(),
    updateReportDetails: type<Partial<EngineReportDetails>>(),
    updateCylinderUnit: type<{ index: number; changes: Partial<EngineReportCylinderUnit> }>(),
    trimCylinderUnits: type<{ count: number }>(),
    setComments: type<string>(),
    reset: type<void>(),
  },
});
